import React from 'react';
import EventTable from './table';
import { incidentsColumns } from './config';

export default function Incidents({ selectedProject }) {
  return (
    <EventTable
      selectedProject={selectedProject}
      columnsConfig={incidentsColumns}
      widget="supplyChainMonitoring"
      typeOfEvent="riskMitigationMeasures"
    />
  )
}
